import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'resultadosCGO2',
  templateUrl: './resultadosCGO2.component.html',
  styleUrls: ['./resultadosCGO2.component.scss']
})
export class ResultadosCGO2Component implements OnInit {

  mailUsuario: string;
  urlCA = 'https://fenix.gptw.mx/reportes/general/cgo5link.php?usr=';
  urlSafe: SafeResourceUrl;
  constructor(
    public authService: AuthService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.getDatosSide();
  }

  getDatosSide(){
    let esperaDatos = setInterval( () => {
      if(this.authService.getIsAuth())
      {
        if(this.authService.getInfoUsuario() != null){
          if(this.mailUsuario == null){

            this.mailUsuario = this.authService.getInfoUsuario().user;
            this.urlCA = this.urlCA + this.mailUsuario;
            this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.urlCA);
            // console.log(this.urlCA);

            clearInterval(esperaDatos);
          }
        }

      }
    }, 0);
  }

}
